<template>
    <a-table
        size="small"
        :columns="columns"
        :data-source="rows"
        row-key="key"
        :loading="loading"
        :pagination="false"
        :locale="{ emptyText: 'Nenhum EAN encontrado.' }"
    >
        <template slot="ean" slot-scope="text, row">
            <span class="pea-strong">{{ text }}</span>
            <a-tag v-if="row.main" color="blue" class="pea-tag">Principal</a-tag>
        </template>
        <template slot="source" slot-scope="text">
            <a-tag v-if="text">{{ sourceLabel(text) }}</a-tag>
            <span v-else>--</span>
        </template>
        <template slot="date" slot-scope="text">{{ formatDate(text) }}</template>
    </a-table>
</template>

<script>
import moment from "moment";

const SOURCES = { MANUAL: "Manual", INTELLIGENCE: "Intelligence", IMPORT: "Importação" };

export default {
    name: "ProductEans",
    props: {
        product: { type: Object, required: true },
        eans: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    data() {
        return {
            columns: [
                { title: "EAN", dataIndex: "ean", key: "ean", scopedSlots: { customRender: "ean" } },
                { title: "Origem", dataIndex: "source", key: "source", align: "center", scopedSlots: { customRender: "source" } },
                { title: "Cadastrado em", dataIndex: "created_at", key: "created_at", align: "center", scopedSlots: { customRender: "date" } },
            ],
        };
    },
    computed: {
        rows() {
            const main = this.product.pro_ean ? [{ key: "main", ean: this.product.pro_ean, main: true }] : [];
            return main.concat(this.eans.map((ean) => ({ ...ean, key: ean.id })));
        },
    },
    methods: {
        formatDate(value) {
            return value ? moment(value).format("DD/MM/YYYY") : "--";
        },
        sourceLabel(value) {
            return SOURCES[value] || value;
        },
    },
};
</script>

<style lang="scss" scoped>
.pea-strong {
    font-weight: 600;
    color: #262626;
}
.pea-tag {
    margin-left: 8px;
}
</style>
